import React from 'react'
import logo from '../assets/img/KinoPoisk-Logo.wine.png'

export default function Logo() {
  return (
    <div className='logo'><img src={logo} alt='Логотип' /></div>
  )
}
